import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

interface CombinationWarningProps {
  className?: string;
}

const CombinationWarning: React.FC<CombinationWarningProps> = ({ className = '' }) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className={`${className} relative inline-block`}>
            <AlertTriangle
              className="text-amber-500 animate-[tilt_2s_ease-in-out_infinite_alternate]"
              size={20}
            />
          </div>
        </TooltipTrigger>
        <TooltipContent side="top">
          <p className="max-w-xs">
            You've done this combination before! On some occasions you may get different results...
            the risk is yours to take!
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default CombinationWarning;
